<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #TasasApp
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Tasas

    v-dialog(v-model='dialog', persistent max-width='600px')
          v-btn.mb-2(v-if='cre' slot='activator', style="border-radius:5px;background-color:#ff6500;") Nueva Tasa
          v-container(style='background-color:white !important;max-width: 600px;')
            v-card-title.justify-center
                span.headline Tasa
            div(style="margin-top: 20px; padding: 20px;")
                v-flex(xs12, sm12, md12)
                    v-form(ref="form", v-model="valid")
                      v-text-field(
                        outline
                        v-model="form.tasa"
                        :rules="tasaRules"
                        label="Tasa"
                        type="number"
                        step="0.01"
                        prepend-inner-icon="attach_money"
                        required
                      )
                      
                      v-layout(row wrap)
                        v-flex(xs12 sm6)
                          v-menu(
                            v-model="menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="300px"
                            content-class="elevation-3"
                          )
                            template(v-slot:activator="{ on, attrs }") 
                              v-text-field(
                                :value="dateValue || ''"
                                label="Fecha"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outline
                                dense
                                :rules="[v => !!v || 'La fecha es requerida']"
                                class="mr-2"
                              )
                            v-date-picker(
                              v-model="dateValue"
                              no-title
                              scrollable
                              :max="new Date().toISOString()"
                              color="primary"
                              header-color="primary"
                              :first-day-of-week="1"
                              @input="updateDate"
                              dark
                              class="date-picker-custom"
                            )
                        v-flex(xs12 sm6)
                          v-menu(
                            v-model="timeMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="300px"
                            content-class="elevation-3"
                          )
                            template(v-slot:activator="{ on, attrs }") 
                              v-text-field(
                                v-model="timeValue"
                                label="Hora"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outline
                                dense
                                :rules="[v => !!v || 'La hora es requerida']"
                              )
                            v-time-picker(
                              v-model="timeValue"
                              format="24hr"
                              scrollable
                              full-width
                              color="primary"
                              header-color="primary"
                              @change="updateTime"
                              @click:minute="timeMenu = false"
                            )

                      div(style='display: flex;justify-content: center;margin: 20px;')
                        v-flex(v-if="loading === true", xs12 sm12 md12)
                          v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                            v-progress-circular(indeterminate='', color='primary')
                        v-flex(v-if="loading === false", xs12 sm12 md12)
                          v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                              v-btn(style="background:#ff6500;border-radius:10px; margin-right: 10px", @click.native='save', :disabled="!valid") Guardar
                              v-btn(style="background:black;border-radius:10px;" @click.native='close') Cancelar

    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
            v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                span.white--text Lista de Tasas
        v-data-table.elevation-1(:headers='headers', :items="resultados", style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td {{ props.item.tasa }}
            td {{ props.item.usuario }}
            td {{ formatFecha(props.item.fechaCreacion) }}
            td
</template>

<script>
import Api from "@/services/methods";
import moment from 'moment';

export default {
  name: "mTasasApp",
  data: () => ({
    valid: true,
    loading: false,
    menu: false,
    timeMenu: false,
    timeValue: null,
    dateValue: new Date().toISOString().substr(0, 10),
    form: {
      tasa: null,
      usuario: "",
      fechaCreacion: new Date().toISOString()
    },
    dialog: false,
    menu: false,
    timeMenu: false,
    editedIndex: -1,
    resultados: [],
    headers: [
      { text: "Tasa", value: "tasa" },
      { text: "Usuario", value: "usuario" },
      { text: "Fecha Creación", value: "fechaCreacion" },
    ],
    defaultForm: {
      tasa: null,
      usuario: "",
      fechaCreacion: new Date()
    },
    cre: "",
    mod: "",
    elm: "",

    // Reglas de validación
    tasaRules: [
      v => !!v || 'La tasa es requerida',
      v => !isNaN(v) || 'Debe ser un número',
      v => v > 0 || 'Debe ser un número positivo'
    ],
    usuarioRules: [
      v => !!v || 'El usuario es requerido',
      v => (v && v.length >= 2) || 'El usuario debe tener al menos 2 caracteres'
    ]
  }),
  created() {
    this.verificacion();
    this.initialize();
    const now = new Date();
    const currentTime = now.getHours().toString().padStart(2, '0') + ':' + now.getMinutes().toString().padStart(2, '0');
    this.timeValue = currentTime;
  },
  methods: {
    formatTime(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0');
    },
    
    verificacion() {
      for (let i = 0; i < this.$store.state.adminsafiro.permisos.length; i++) {
        if (this.$store.state.adminsafiro.permisos[i].ruta === "TasasApp") {
          for (
            let j = 0;
            j < this.$store.state.adminsafiro.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminsafiro.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },

    formatFecha(fecha) {
      if (!fecha) return 'N/A';
      // Ajustar fecha sumando 4 horas para mostrar en zona horaria Venezuela
      const fechaAjustada = new Date(fecha);
      fechaAjustada.setHours(fechaAjustada.getHours() + 4);
      return moment(fechaAjustada).format('DD/MM/YYYY HH:mm');
    },
    
    formatDateForInput(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DDTHH:mm');
    },
    
    parseDate(dateString) {
      if (!dateString) return new Date();
      return moment(dateString, 'YYYY-MM-DDTHH:mm').toDate();
    },

    formatTasa(tasa) {
      return tasa ? tasa.toFixed(2) : '0.00';
    },

    initialize() {
      this.$refs.form && this.$refs.form.reset();
      Api.get("tasasApp").then(res => {
        this.resultados = res.data;
      }).catch(error => {
        console.error('Error cargando tasas:', error);
        this.$swal.fire(
          "Error",
          "Error al cargar las tasas",
          "error"
        );
      });
    },

    editItem(item) {
      this.editedIndex = this.resultados.indexOf(item);
      this.form = Object.assign({}, item);
      
      // Inicializar fecha y hora
      let date = this.form.fechaCreacion ? moment(this.form.fechaCreacion) : moment();
      
      // Asegurar que la fecha sea válida
      if (!date.isValid()) {
        date = moment();
      }
      
      this.form.fechaCreacion = date.toISOString();
      this.dateValue = date.format('YYYY-MM-DD');
      this.timeValue = date.format('HH:mm');
      
      this.dialog = true;
    },

    deleteItem(item) {
      this.$swal
        .fire({
          title: "¿Estás seguro?",
          text: "No podrás revertir esta acción",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar"
        })
        .then(result => {
          if (result.value) {
            Api.delete(`tasasApp/${item._id}`).then(() => {
              this.initialize();
              this.$swal.fire(
                "¡Eliminado!",
                "La tasa ha sido eliminada.",
                "success"
              );
            }).catch(error => {
              console.error('Error eliminando tasa:', error);
              this.$swal.fire(
                "Error",
                "Error al eliminar la tasa",
                "error"
              );
            });
          }
        });
    },

    updateTime(time) {
      if (!time) return;
      
      const [hours, minutes] = time.split(':');
      const date = this.dateValue ? moment(this.dateValue) : moment();
      
      date.hours(parseInt(hours, 10));
      date.minutes(parseInt(minutes, 10));
      
      this.form.fechaCreacion = date.toISOString();
      this.timeValue = time;
      this.timeMenu = false;
    },
    
    updateDate(date) {
      if (!date) return;
      
      const selectedDate = moment(date);
      const currentTime = this.timeValue ? moment(this.timeValue, 'HH:mm') : moment();
      
      // Combinar la fecha seleccionada con la hora actual
      selectedDate.hours(currentTime.hours());
      selectedDate.minutes(currentTime.minutes());
      
      this.form.fechaCreacion = selectedDate.toISOString();
      this.dateValue = date;
      this.menu = false;
    },
    
    close() {
      this.form = Object.assign({}, this.defaultForm);
      const now = new Date();
      this.form.fechaCreacion = now.toISOString();
      this.dateValue = now.toISOString().substr(0, 10);
      this.timeValue = this.formatTime(now);
      this.editedIndex = -1;
      this.dialog = false;
      this.menu = false;
      this.timeMenu = false;
      this.$refs.form && this.$refs.form.reset();
    },

    save() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        // Asegurarse de que la fecha tenga segundos y milisegundos
        let fechaCreacion = this.form.fechaCreacion;
        if (fechaCreacion) {
          // Si es un string en formato YYYY-MM-DDTHH:mm, agregar segundos
          if (typeof fechaCreacion === 'string' && fechaCreacion.length === 16) {
            fechaCreacion += ':00';
          }
        }

        const data = {
          tasa: parseFloat(this.form.tasa),
          usuario: this.$store.state.adminsafiro._id,
          fechaCreacion: fechaCreacion || new Date().toISOString()
        };

        if (this.editedIndex > -1) {
          // Actualizar
          Api.put(`tasasApp/${this.resultados[this.editedIndex]._id}`, data).then(res => {
            Object.assign(this.resultados[this.editedIndex], res.data);
            this.close();
            this.$swal.fire(
              "¡Actualizado!",
              "La tasa ha sido actualizada.",
              "success"
            );
          }).catch(error => {
            console.error('Error actualizando tasa:', error);
            this.$swal.fire(
              "Error",
              "Error al actualizar la tasa",
              "error"
            );
          }).finally(() => {
            this.loading = false;
          });
        } else {
          // Crear
          Api.post("tasasApp", data).then(res => {
            this.resultados.push(res.data);
            this.close();
            this.$swal.fire(
              "¡Creado!",
              "La tasa ha sido creada.",
              "success"
            );
          }).catch(error => {
            console.error('Error creando tasa:', error);
            this.$swal.fire(
              "Error",
              "Error al crear la tasa",
              "error"
            );
          }).finally(() => {
            this.loading = false;
          });
        }
      }
    }
  }
};
</script>

<style scoped>
/* Estilos personalizados para el date picker */
.date-picker-custom {
  background-color: white !important;
  color: #333 !important;
  border-radius: 4px;
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}

.date-picker-custom .v-date-picker-header {
  background-color: #1976d2 !important;
  color: white !important;
}

.date-picker-custom .v-date-picker-table th {
  color: #333 !important;
}

.date-picker-custom .v-date-picker-table--date .v-btn {
  color: #333 !important;
}

.date-picker-custom .v-date-picker-table--date .v-btn--active {
  background-color: #1976d2 !important;
  color: white !important;
}

.v-data-table {
  background-color: white;
}

.theme--light.v-data-table {
  background-color: white;
  color: rgba(0, 0, 0, 0.87);
}

.v-data-table .v-data-table-header th {
  background-color: #f5f5f5;
  font-weight: bold;
}
</style>
